<template>
  <div class="card">
    <div class="card-header">
      <h3>Shift Sign-ups</h3>
      <small class="form-text text-muted">
        Settlement figures are a snapshot taken when the shift was settled. They do not move with later
        tips, refunds or fare adjustments &mdash; earnings history is the live money record. "Credited"
        means the guarantee was added to the driver's earnings; the Payout column is whether the
        transfer actually landed.
      </small>
    </div>
    <div class="card-body">
      <DataTable
          :ajax="{ url: `/api/datatable/shift-signups?shiftId=${props.shiftId}` }"
          ref="signupsDataTable"
          class="table-responsive display"
          :columns="signupColumns"/>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net-bs5';
import {
  earningTransferStatus,
  optionalCurrency,
  potentialUndefinedColumn,
  shiftSignupStatus,
  zonedDateTime
} from '../utility/DatatableRenderer';

DataTable.use(DataTablesCore);

const props = defineProps({
  shiftId: {
    type: String,
    default: null
  }
});

const signupsDataTable = ref(null);

// Every admin table in this app ships whole and lets DataTables.net paginate and search client-side
// (CLAUDE.md); a shift's roster is bounded by its maxDrivers, so it is nowhere near needing more.
const signupColumns = [
  {
    data: 'driverName',
    title: 'Driver',
    // Falls back to the id: a driver record with no name at all still has to be identifiable, since
    // this table exists to resolve "which driver was not paid".
    render: (data, type, row) => potentialUndefinedColumn(data || row.driverId)
  },
  { data: 'status', title: 'Sign-up status', render: shiftSignupStatus },
  { data: 'signedUpAt', title: 'Signed up', render: zonedDateTime },
  { data: 'settledAt', title: 'Settled', render: zonedDateTime },
  { data: 'guaranteedEarnings', title: 'Guaranteed', render: optionalCurrency },
  { data: 'actualEarnings', title: 'Earned in window', render: optionalCurrency },
  { data: 'guaranteeCredited', title: 'Guarantee credited', render: optionalCurrency },
  { data: 'earningTransferStatus', title: 'Payout', render: earningTransferStatus },
  { data: 'outcomeReason', title: 'Outcome', render: potentialUndefinedColumn }
];
</script>
